module.exports = __webpack_public_path__ + "img/hoozieRewardsField1Mobile.58acd19d.svg";